import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const StardustAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 0; i < 30; i++) {
    const angle = (i * 137.5) * Math.PI / 180;
    const dist = e.maxRadius + progress * 150;
    const r = getRadiusAtAngle(angle + progress * 2, e, dist);
    const px = e.pos.x + Math.cos(angle + progress * 2) * r;
    const py = e.pos.y + Math.sin(angle + progress * 2) * r;
    const sz = 4 * (1 - progress);
    ctx.beginPath(); ctx.arc(px, py, sz, 0, Math.PI * 2); ctx.fill();
  }
};

registerBlastAnimation('STARDUST', StardustAnimation);
